
export function isEmptyCustom(data: any) {

    if (Array.isArray(data) && data.length >= 0 && !data.every((item)=> item !== "")) {
        return true
    } else if (data === '' || data === null || data === undefined) {
        return true;
    } else if (!Array.isArray(data) && typeof data !=="string" && isNaN(data)) {
        return true;
    }

    return false;
}
